import React from 'react';
import { AnimatedSection } from '../shared/AnimatedSection';
import { GlowCard } from '../shared/GlowCard';
import { Sign } from '../../data/signs';
interface SignProblemaProps {
  sign: Sign;
}
export function SignProblema({
  sign
}: SignProblemaProps) {
  const {
    problemaTitle,
    problemaSubtitle,
    problemas
  } = sign.content;
  return <section className="py-20 md:py-28 px-4 md:px-6 bg-transparent" data-id="element-971">
      <div className="container mx-auto max-w-5xl" data-id="element-972">
        <AnimatedSection data-id="element-973">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-center text-white mb-6 leading-tight px-2" data-id="element-974">
            {problemaTitle}
          </h2>
          <h3 className="text-xl md:text-2xl font-serif text-center mb-12 md:mb-16 italic px-4" style={{
          color: sign.colors.accent
        }} data-id="element-975">
            {problemaSubtitle}
          </h3>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6" data-id="element-976">
          {problemas.map((problema, index) => <AnimatedSection key={index} delay={0.2 + index * 0.1} data-id="element-977">
              <GlowCard glowColor={sign.colors.primary} className="h-full p-6 md:p-8" data-id="element-978">
                <p className="text-gray-100 text-lg md:text-xl leading-relaxed font-serif" data-id="element-979">
                  {problema}
                </p>
              </GlowCard>
            </AnimatedSection>)}
        </div>
      </div>
    </section>;
}